import { component } from "picoapp";
import choozy from "choozy";
import { remove, add, qs, on, toggle } from "@selfaware/martha";

import { gsap, ScrollToPlugin } from "gsap/all";
gsap.registerPlugin(ScrollToPlugin);

export default component((node, ctx) => {
  let { scrollHow, scrollSafety } = choozy(node);

  let sectionHowTo = qs('[data-section="how-to-use"]');
  let sectionSafety = qs('[data-section="safety-info"]');

  if (sectionHowTo && scrollHow) {
    on(scrollHow, "click", (e) => {
      gsap.to(window, {
        duration: 1,
        scrollTo: {
          y: sectionHowTo,
          offsetY: 90,
        },
        ease: "expo.out",
      });
    });
  } else if (scrollHow) {
    scrollHow.remove();
  }

  if (sectionSafety && scrollSafety) {
    on(scrollSafety, "click", (e) => {
      gsap.to(window, {
        duration: 1,
        scrollTo: {
          y: sectionSafety,
          offsetY: 90,
        },
        ease: "expo.out",
      });
    });
  } else if (scrollSafety) {
    scrollSafety.remove();
  }
});
